import React, {useContext, useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import Slide from '@material-ui/core/Slide';
import 'mapbox-gl/dist/mapbox-gl.css';
import IconButton from "@material-ui/core/IconButton";
import JString from '@easytech-international-sdn-bhd/jstring';
import API_Service, {axiosDefaultConfig, axiosPutConfig, axiosURIencode} from '../../Services/API_Service';
import AppContext from '../../Services/AppContext';
import {Button, Chip, DialogContent, Grid, Paper} from '@material-ui/core';
import {req_stock, req_stock_category_item, req_stock_def} from '../../Helper/Constants';
import MUIDataTable from 'mui-datatables';
import VirtualListCB from '../VirtualListCB';
import {arrayBufferToBase64, de} from '../../Helper/Helper';
import EditCategory from '../EditCategory';
import EditIcon from '@material-ui/icons/Edit';
import DoneIcon from '@material-ui/icons/Done';
import Tooltip from "@material-ui/core/Tooltip";
import _ from 'lodash';

const useStyles = makeStyles((theme) => ({
	title: {
		marginLeft: theme.spacing(2),
		flex: 1,
	},
	appBar: {
		position: 'relative',
	},
	root: {
		flexGrow: 1
	},
	grid: {
		marginTop: 10,
		paddingLeft: 20,
		paddingRight: 20
	},
	dlgContent: {margin: -20, marginTop: -10},
	paper: {
		padding: 10
	},
	paperMaxHeight: {
		padding: 10,
		maxHeight: 120
	}
}));

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

export default function CategoryDetails({
											item: currentItem,
											open,
											setClose,
											language,
											onUpdateCategory,
											onSnack,
											integration
										}) {
	const [gState] = useContext(AppContext);
	const classes = useStyles();
	const [axiosConfig, setAxiosConfig] = useState({});
	const [tabPosition, setTabPosition] = useState(0);
	const [item, setItem] = useState(currentItem);
	const [showDropzone, toggleDropZone] = useState(true);
	const [openCategoryEdit, setOpenCategoryEdit] = useState(false);
	const [categoryImage, setCategoryImage] = useState(null);
	const [categoryItemData, setCategoryItemData] = useState([]);
	const [newItemListOpen, setNewItemListOpen] = useState(false);
	const [newItemList, setNewItemList] = useState([]);

	useEffect(() => {
		if (JString(gState.client).isValid()) {
			var axiosGetConfig = axiosDefaultConfig(gState.client);
			setAxiosConfig(axiosGetConfig);
		}
	}, [gState?.client]);

	useEffect(() => {
		if (!_.isEmpty(currentItem) && !_.isEmpty(axiosConfig)) {
			loadCategoryItemData();
			loadNewCategoryItemList();
		}
	}, [currentItem, axiosConfig]);

	const onClose = () => {

		setClose();
	}

	const editCategory = (data) => {
		setOpenCategoryEdit(false);
		if (data) {
			setItem(data[0]);
			onUpdateCategory(data[0]);
		}
	}

	const onCategoryImageUpload = (files) => {
		if (files.length > 0) {
			const reader = new FileReader()

			reader.onabort = () => de('file reading was aborted')
			reader.onerror = () => de('file reading has failed')
			reader.onload = () => {
				const binaryStr = reader.result
				setCategoryImage(categoryImage => (binaryStr));
			}
			reader.readAsArrayBuffer(files[0])
		}
	}

	const uploadCategoryImage = () => {
		de('bufferbased64 ==>', arrayBufferToBase64(categoryImage));
		var axiosConfig = axiosPutConfig(gState.client);
		var formdata = new FormData();
		formdata.append('category_code', item.category_code);
		formdata.append('product_image', arrayBufferToBase64(categoryImage));
		// API_Service.post(req_stock_image,formdata,axiosConfig).then(({data})=>{
		//     var { result, extraData } = data;
		//     result = JString(result).toNumber();
		//     if(result === 1){
		//         onSnack && onSnack(language.record_updated,'success');

		//         setCategoryImage(null);
		//         toggleDropZone(false);
		//         setTimeout(() => {
		//             toggleDropZone(true);
		//         }, 100);
		//     }else{
		//         onSnack && onSnack(language.operation_fail,'error');
		//     }
		// });
	}

	const loadCategoryItemData = (config = axiosConfig) => {
		API_Service.get(`${req_stock}${item.category_id}`, _.isEmpty(config) ? axiosConfig : config).then(({data}) => {
			var {result, extraData} = data;
			result = JString(result).toNumber();
			if (result === 0) {
				onSnack(language.no_data, 'warning');
			} else {
				var {category, stock} = extraData;
				setCategoryItemData(() => (stock));
			}
		});
	}

	const loadNewCategoryItemList = (config = axiosConfig) => {
		API_Service.get(req_stock_def, config).then(({data}) => {
			const {result, extraData} = data;
			if (parseInt(result) === 1) {
				const {stock} = extraData;
				var _arr = [];
				for (let i = 0; i < stock.length; i++) {
					const {product_code, product_name, product_status, category_id} = stock[i];
					if (product_status === '1' && category_id === '0') {
						_arr.push({
							name: product_name,
							secondary: product_code,
							value: product_code,
							status: parseInt(product_status)
						});
					}else{
						_arr.push({
							name: product_name,
							secondary: product_code,
							value: product_code,
							hide: true,
							status: parseInt(product_status)
						});
					}
				}

				if (_arr.length > 0) {
					setNewItemList(newItemList => (_arr));
				} else {
					onSnack(language.no_data, 'warning');
				}
			}
		});
	}

	const categoryViewClose = (newValue) => {
		setNewItemListOpen(false);
		if (newValue) {
			if (newValue['name'] != 'reset') {
				var formdata = new FormData();
				formdata.append('category_id', item.category_id);
				formdata.append('product', JSON.stringify(newValue));

				API_Service.post(req_stock_category_item, formdata, axiosConfig).then(({data}) => {
					var {result, extraData} = data;
					result = JString(result).toNumber();
					if (result === 1) {
						var {stock} = extraData;
						setCategoryItemData(() => (stock ? stock : []));
						loadNewCategoryItemList();
						onSnack && onSnack(language.record_updated, 'success');
					} else {
						onSnack && onSnack(language.operation_fail, 'error');
					}
				});
			}
		} else {

		}
	}

	return (
		<div className={classes.root}>
			<Dialog fullScreen open={open} onClose={() => onClose()} TransitionComponent={Transition}>
				<AppBar className={classes.appBar}>
					<Toolbar>
						<IconButton edge="start" color="inherit" onClick={() => onClose()} aria-label="close">
							<CloseIcon/>
						</IconButton>
						<Typography variant="h6" className={classes.title}>
							{language.category_details}
						</Typography>
					</Toolbar>
				</AppBar>
				<DialogContent className={classes.dlgContent}>
					<Grid container spacing={3} className={classes.grid}>
						<Grid item xs={4}>
							<Paper className={classes.paper}>
								<Grid container spacing={2}>
									<Grid item xs={12} lg direction="column" container>
										<Typography variant="subtitle1" className={classes.textleft}>
											{item.categoryIdentifierId}
										</Typography>
										<Typography variant="inherit" component="h4" className={classes.textleft}>
											{item.category_name}
										</Typography>
									</Grid>
									{
										integration === '0' && (
											<Button
												onClick={() => setOpenCategoryEdit(true)}
												size="small">
												<EditIcon/>
											</Button>
										)
									}
								</Grid>
							</Paper>
						</Grid>
						<Grid item xs={8}>
							<CategoryItemList
								data={categoryItemData}
								language={language}
								gState={gState}
								onEvent={() => loadCategoryItemData()}
								onSnack={onSnack}
								setNewItemListOpen={setNewItemListOpen}
								item={item}
							/>
						</Grid>
					</Grid>
				</DialogContent>
			</Dialog>
			<EditCategory
				open={openCategoryEdit}
				onClose={(data) => editCategory(data)}
				language={language}
				category_code={item.categoryIdentifierId}
				category_name={item.category_name}
			/>
			{
				newItemListOpen && (
					<VirtualListCB
						setClose={(d) => categoryViewClose(d)}
						open={newItemListOpen}
						title={'New Category Items'}
						data={newItemList}
						language={language}
						filteration={0}
					/>
				)
			}
		</div>
	)
}

function Space({height = 10}) {
	return (
		<div style={{height}}/>
	)
}

function CategoryItemList({data, language, gState, onEvent, onSnack, setNewItemListOpen, item}) {
	const onRowDelete = (row) => {
		const _arr = [];
		for (let i = 0; i < row.length; i++) {
			var {dataIndex} = row[i];
			_arr.push(data[dataIndex]['product_code']);
		}
		var axiosPut = axiosPutConfig(gState.client);
		var params = axiosURIencode({
			product: _arr.join(","),
			ori_code: item.category_id
		});

		API_Service.put(req_stock_category_item, params, axiosPut).then(({data}) => {
			var {result} = data;
			result = JString(result).toNumber();
			if (parseInt(result) === 1) {
				onSnack(language.record_updated, 'success');
			} else {
				onSnack(language.operation_fail, 'error');
			}
			onEvent();
		});
	}
	return (
		<MUIDataTable
			title={language.category_list}
			data={data || []}
			columns={itemDataCell}
			options={{
				print: false,
				filter: false,
				rowsPerPage: 125,
				rowsPerPageOptions: [125, 140, 165, 200],
				responsive: 'scrollMaxHeight',
				download: false,
				viewColumns: false,
				selectableRows: data.length > 0 ? 'multiple' : 'none',
				onRowsDelete: ({data: row}) => onRowDelete(row),
				setTableProps: () => ({size: 'small'}),
				customToolbar: () =>
					<TemplateTableCustomToolbar
						addCateogryItem={() => {
							setNewItemListOpen(true)
						}}
					/>
			}}
		/>
	)
}

const itemDataCell = [
	{
		name: "product_code",
		label: "Code",
		options: {
			display: true
		}
	},
	{
		name: "product_name",
		label: "Name",
		options: {
			display: true
		}
	},
	{
		name: "product_desc",
		label: "Description",
		options: {
			display: true,
			customBodyRender: (value, tableMeta, updateValue) => {
				return <p>{JString(value).trimHtml().str || '-'}</p>;
			}
		}
	},
	{
		name: "product_status",
		label: "Status",
		options: {
			display: true,
			sort: false,
			customBodyRender: (value, tableMeta, updateValue) => {
				const {rowIndex: dataIndex} = tableMeta;
				switch (value) {
					case "1" :
						return (
							<Chip size="small" icon={<DoneIcon/>} label="Active"/>
						);
						break;
					case "0" :
						return (
							<Chip size="small" icon={<CloseIcon/>} label="Inactive"/>
						);
						break;
						break;
					default :
						return (null);
						break;
				}
			}
		}
	}
];

function TemplateTableCustomToolbar({addCateogryItem}) {
	return (
		<React.Fragment>
			<Tooltip title={'Add Into Category'}>
				<IconButton
					edge={'end'}
					color={'primary'}
					onClick={() => addCateogryItem()} aria-label="addnew">
					<AddIcon/>
				</IconButton>
			</Tooltip>
		</React.Fragment>
	)
}
